import { Injectable, signal } from "@angular/core";
import { ColDef, GridApi } from "ag-grid-community";

@Injectable()
export class BaseGridService {
  gridApi!: GridApi;

  colDefs = signal<ColDef[]>([]);

  setGridApi(gridApi: GridApi): void {
    this.gridApi = gridApi;
  }

  setColDefs(actionColumn: ColDef): void {
    const colDefs = [actionColumn];
    this.colDefs.set(colDefs);
  }
}
